<template>
  <div>
    <div class="skill-card-list">
      <SkillsCard 
        :title="$t('app.campaign.recap.skillCard.required')" 
        :skills="requiredSkills"
        coefficient="coeff. 3"
      />
      <SkillsCard 
        :title="$t('app.campaign.recap.skillCard.important')" 
        :skills="importantSkills"
        coefficient="coeff. 2"
      />
      <SkillsCard 
        :title="$t('app.campaign.recap.skillCard.secondary')"
        :skills="secondarySkills"
        coefficient="coeff. 1"
      />
      <SkillsCard 
        :title="$t('app.campaign.recap.skillCard.ignored')" 
        :skills="ignoredSkills"
      />
    </div>
    <div class="styles-wrapper" v-if="skillsStore.isCampaignV3OrMore(props?.campaignVersion)">
      <div class="assessed-or-ignored-styles">
        <div class="title">{{ $t('app.campaign.recap.skillCard.assessedStyles') }}</div>
        <div class="style-list" v-if="assessedStyles?.length">
          <div class="item" v-for="style in assessedStyles">{{ skillLocale(style) }}</div>
        </div>
        <div v-else>{{ $t('app.campaign.recap.skillCard.none') }}</div>
      </div>
      <div class="assessed-or-ignored-styles">
        <div class="title">{{ $t('app.campaign.recap.skillCard.ignoredStyles') }}</div>
        <div class="style-list" v-if="ignoredStyles?.length">
          <div class="item" v-for="style in ignoredStyles">{{ skillLocale(style) }}</div>
        </div>
        <div v-else>{{ $t('app.campaign.recap.skillCard.none') }}</div>
      </div>
    </div>
  </div>
</template>


<script lang="ts" setup>
import SkillsCard from '@/components/campaigns/weighting/SkillsCard.vue';
import { ModuleLabel } from '@/types/campaign';

const { t, te } = useI18n();
const skillsStore = useSkillsStore();

const props = defineProps<{
  requiredSkills: string[],
  importantSkills: string[],
  secondarySkills: string[],
  ignoredSkills: string[],

  allModules?: ModuleLabel[],
  campaignVersion: string,
}>();

const assessedStyles = computed(() => {
  if (!props?.allModules) return [];
  return props.allModules.filter((mod) => {
    return skillsStore.styleSkills.find((s) => !s.disabled && s.id === mod && !s.incompatible_versions.includes(props.campaignVersion));
  })
});

const ignoredStyles = computed(() => {
  if (!props?.allModules) return [];
  return skillsStore.styleSkills.filter((s) => !s.disabled && !s.incompatible_versions.includes(props.campaignVersion) && !props.allModules.includes(s.id as ModuleLabel)).map((s) => s.id);
});

function skillLocale(internal_name: string) {
  if (te(`skills.${internal_name}.name`)) {
    return t(`skills.${internal_name}.name`);
  }
  const skillInfo = skillsStore.skills.find(v => v.id === internal_name);
  if (te(`skills.${skillInfo?.id}.name`)) {
  } else if (te(`skills.${skillInfo?.id_v2}.name`)) {
    return t(`skills.${skillInfo?.id_v2}.name`);
  } else {
    return t(`skills.${skillInfo?.id_v1}.name`);
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.skill-card-list {
  margin: 8px 0;
  display: flex;
  gap: 10px;
  align-items: center;

  .skills-card {
    flex: 1;
    align-self: stretch;
    min-height: 150px;
  }
}

.styles-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;

  .assessed-or-ignored-styles {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;

    .title {
      border-radius: 4px;
      color: var(--$black-color);
      text-align: center;
      font-style: normal;
      font-weight: 600;
    }

    .style-list {
      display: flex;
      align-items: center;
      gap: 8px;

      .item {
        display: flex;
        padding: 5px 8px;

        background-color: var(--primary-100-color);
        border: 1px solid $primary-color;
        border-radius: 4px;

        font-size: 12px;
        font-weight: 500;
      }
    }
  }
}
</style>